import { render } from "./member-properties.vue?vue&type=template&id=308abf2e"
import script from "./member-properties.vue?vue&type=script&lang=js"
export * from "./member-properties.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__